import React, { useState, useRef } from 'react';
import classnames from 'classnames';

import DropdownMenu from './DropdownMenu';
import BusinessLoactionsItem from './BusinessLocationItem';

const searchLocation = (locations, searchkey) => {
  if (searchkey) {
    const filered_locations = locations.filter(location => location.business_name.toUpperCase().includes(searchkey.toUpperCase()));
    return sorttLocationAlphabetically(filered_locations);
  } else {
    return sorttLocationAlphabetically(locations);
  }
};
const sorttLocationAlphabetically = (locations) => {
  locations.sort((a, b) => { return a.business_name.localeCompare(b.business_name); });
  return locations.sort((a, b) => { return a.brand_ids.includes(a.studioId) ? -1 : b.brand_ids.includes(b.studioId) ? 1 : 0; });
};
const BusinessLoactions = ({
  onChange,
  selectedOption,
  dropdownMenu,
  ...rest
}) => {
  const [search, inputSearch] = useState();
  const textInput = useRef(null);
  dropdownMenu.sort(function (x, y) { return x.brand_ids.includes(x.studioId) ? -1 : y.brand_ids.includes(y.studioId) ? 1 : 0; });
  return (
    <DropdownMenu {...rest} searchref={textInput}>
      <div className="search-box">
        <div className="input-holder">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={e => inputSearch(e.target.value)}
            className="location-search"
            ref={textInput}
          />
          <i className="material-icons">search</i>
        </div>
      </div>
      <div className="locations-list">
        {/* eslint react/no-array-index-key: "off" */
          searchLocation(dropdownMenu, search).map((item, index) => {
            return (
              <BusinessLoactionsItem
                label={item.business_name}
                search={search}
                key={index}
                value={item}
                onClick={onChange}
                type="BUTTON"
                className={classnames('location', { 'active': selectedOption.studioId === item.studioId })}
              />
            );
          })}
      </div>
    </DropdownMenu>
  );
};

export default BusinessLoactions;
